import React from "react";
import $ from "jquery";
export default class TestMainScore extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    // console.log(this.props.inning);
    if (this.props.inning.status_str == "Completed") {
      $(".blbat_none").hide();
    }
    this.getBattingTeam();
  }

  getBattingTeam = () => {
    //initial assignment
    this.props['inning']['teama']['action'] = "";
    this.props['inning']['teamb']['action'] = "";

    try {
      let batObj = this.props['inning']['innings'];
      let curIng = batObj[Object.keys(batObj).length - 1];
      let batingteamId = curIng['batting_team_id'];
      let bollingteamId = curIng['fielding_team_id'];

      // assingment of batting 
      if (Object.is(this.props['inning']['teama']['team_id'], batingteamId)) {
        this.props['inning']['teama']['action'] = "Batting";
      } else if (Object.is(this.props['inning']['teamb']['team_id'], batingteamId)) {
        this.props['inning']['teamb']['action'] = "Batting";
      }

      // assingment of bolling

      if (Object.is(this.props['inning']['teama']['team_id'], bollingteamId)) {
        this.props['inning']['teama']['action'] = "Bowling";
      } else if (Object.is(this.props['inning']['teamb']['team_id'], bollingteamId)) {
        this.props['inning']['teamb']['action'] = "Bowling";
      }


      //put in state 

      this.setState({ ...this.props });

    } catch (e) {

      console.log("error in assingment", e.message);
      return true
    }

  }
  render() {
    // console.log("state inside testmainscore",this.state);
    // console.log(this.props);
    // let inning = this.state;
    let teamA = this.props.inning ? this.props.inning.teama : "";
    let teamB = this.props.inning ? this.props.inning.teamb : "";
    // console.log("teamA",teamA);
    // console.log("teamB",teamB);
    return (
      <div>
        <div className="testmatch_main_score">
          <div className="pos_rel ">

            {(teamA && teamA['action'] == "Batting") ? (
              <div className="widget_body_section">
                <div className="widget2_body_column_left ">
                  <div className="flex_column ">
                    <h4 className="bluebold16">{teamA["name"]}</h4>
                    <h5 className="opt_bat_bowl mt4 blbat_none">{teamA['action'] ? teamA['action'] : ""}</h5>
                  </div>
                </div>
                <div className="widget2_body_column_right ">
                  <div className="justify_center ">
                    <h4 className="blueblack16 center_align">
                      {teamA["scores_full"]}
                    </h4>
                  </div>
                </div>
              </div>
            ) : (
                <div className="widget_body_section">
                  <div className="widget2_body_column_left ">
                    <div className="flex_column ">
                      <h4 className="bluebold16">{teamB["name"]}</h4>
                      <h5 className="opt_bat_bowl mt4 blbat_none">{teamB['action'] ? teamB['action'] : ""}</h5>
                    </div>
                  </div>
                  <div className="widget2_body_column_right ">
                    <div className="justify_center ">
                      <h4 className="blueblack16 center_align">
                        {teamB["scores_full"] || "0/0 (0.0 ov)"}
                      </h4>
                    </div>
                  </div>
                </div>
              )}

            <div className="verticle_hr">
              <h4 className="vs2">vs</h4>
            </div>

            {(teamB && teamB['action'] == "Bowling") ? (
              <div className="widget_body_section">
                <div className="widget2_body_column_left ">
                  <div className="flex_column ">
                    <h4 className="bluebold16 text_green"> {teamB["name"]}</h4>
                    <h5 className="opt_bat_bowl text_green mt4 blbat_none">
                      {teamB['action'] ? teamB['action'] : ""}
                    </h5>

                  </div>
                </div>
                <div className="widget2_body_column_right ">
                  <div className="flex_column  alignrightfix">
                    <h4 className="blueblack16  text_green center_align">
                      {teamB["scores_full"]}
                      {/* <span className="overcount text_green ml5">
                        (16.5 ov) 
                      </span> */}
                    </h4>

                  </div>
                </div>
              </div>
            ) : (
                <div className="widget_body_section">
                  <div className="widget2_body_column_left ">
                    <div className="flex_column ">
                      <h4 className="bluebold16 text_green"> {teamA["name"]}</h4>
                      <h5 className="opt_bat_bowl text_green mt4 blbat_none">
                        {teamA['action'] ? teamA['action'] : ""}
                      </h5>

                    </div>
                  </div>
                  <div className="widget2_body_column_right ">
                    <div className="flex_column  alignrightfix">
                      <h4 className="blueblack16  text_green center_align">
                        {teamA["scores_full"] || "0/0 (0.0 ov)"}
                        {/* <span className="overcount text_green ml5">
                      (16.5 ov) 
                    </span> */}
                      </h4>

                    </div>
                  </div>
                </div>
              )}
            <p className="needruns text_green">
              {
                this.props.inning ? this.props.inning.status_note : ""
              }
            </p>
          </div>

          <div className="grd_line" />
        </div>
      </div>
    );
  }
}
